/**
 * 成就面板
 */

import type { PlayerState } from '../engine/Player';
import { getAllWithStatus, type UnlockedAchievement } from '../engine/AchievementSystem';
import type { Achievement } from '../data/achievements';

export class AchievementPanel {
  private overlay: HTMLElement | null = null;

  open(player: PlayerState): void {
    if (this.overlay) this.overlay.remove();
    const all = getAllWithStatus(player);
    const unlocked = all.filter((a) => a.unlocked).length;

    this.overlay = document.createElement('div');
    this.overlay.className = 'modal-overlay';

    const items = all.map(({ achievement: a, unlocked: u }) => `
      <div class="achievement-item ${u ? 'unlocked' : 'locked'}">
        <span style="font-size:1.4em;">${u ? a.icon : '🔒'}</span>
        <div style="flex:1;">
          <div style="color:${u ? 'var(--text-gold)' : 'var(--text-secondary)'};font-weight:bold;">${a.name}</div>
          <div style="font-size:0.75em;color:var(--text-secondary);">${a.desc}</div>
          ${u ? `<div style="font-size:0.7em;color:var(--success);">${a.rewardDesc}</div>` : ''}
        </div>
      </div>
    `).join('');

    this.overlay.innerHTML = `
      <div class="modal" style="max-width:420px;max-height:75vh;overflow-y:auto;">
        <h2>🏆 成就 <span style="font-size:0.7em;color:var(--text-secondary);">${unlocked}/${all.length}</span></h2>
        <div style="display:flex;flex-direction:column;gap:4px;">${items}</div>
        <button class="btn btn-small" id="ach-close" style="margin-top:12px;">关闭</button>
      </div>
    `;

    document.body.appendChild(this.overlay);
    document.getElementById('ach-close')?.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', (e) => { if (e.target === this.overlay) this.close(); });
  }

  close(): void { if (this.overlay) { this.overlay.remove(); this.overlay = null; } }

  /** 显示解锁弹窗 */
  static showUnlockToast(ach: Achievement): void {
    const toast = document.createElement('div');
    toast.style.cssText = `
      position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:2000;
      background:linear-gradient(135deg,rgba(40,30,10,0.95),rgba(20,15,5,0.95));
      border:2px solid var(--text-gold);border-radius:10px;padding:12px 20px;
      color:var(--text-gold);font-size:0.95em;text-align:center;
      box-shadow:0 0 30px rgba(200,160,60,0.3);animation:achievementPop 0.5s ease-out, achievementFade 0.5s 3s ease-out forwards;
      pointer-events:none;
    `;
    toast.innerHTML = `<div style="font-size:1.5em;">${ach.icon}</div><div>🏆 成就解锁</div><div style="font-weight:bold;">${ach.name}</div><div style="font-size:0.8em;color:var(--success);">${ach.rewardDesc}</div>`;
    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3500);
  }
}
